import React from 'react';
import { Col, Row } from 'react-bootstrap';
import NavMenu from './NavMenuPublic'
import SiteFooter from '../SiteFooter';

const LayoutPublic =  props => (
    <React.Fragment>        
        <div className="flex-wrapper">
            <NavMenu hideBrand={props.hideBrand} tagline={props.tagline} />

            <div className="content">

                <Row>
                    <Col className="container">
                        {props.children}
                    </Col>

                </Row>
            </div>
            <SiteFooter showExtendedFooter={props.showExtendedFooter} />
        </div>
    </React.Fragment>
);

export default LayoutPublic;